'use client'
import type { ImageLoaderProps } from 'next/image';
import Image from 'next/image';


// A component to take advantage of next ability to resize images, and still use a CDN to serve them
// Using a loader globally seems to disable the resizing functionality, so this component is a workaround

export const cdnLoader = ({ src, width, quality }: ImageLoaderProps) => {
    let urlString: string = process.env.NEXT_PUBLIC_TRAILWAYS_IMAGES_CDN || "";
    const params = [];

    urlString += "/_next/image"
    params.push({ name: 'url', value: src })
    params.push({ name: 'w', value: width?.toString() || "" })
    params.push({ name: 'q', value: quality?.toString() || "75" })

    const url = new URL(urlString);
    for (const param of params) {
        url.searchParams.append(param.name, param.value);
    }
    return url.href;
}

const ResizedCdnImage = (props: any) => {
    let srcString: string | null = null;
    if (props.src && props.src.src) {
        srcString = props.src.src;
    } else if (props.src) {
        srcString = props.src;
    }
    const isSvg = srcString && srcString.endsWith(".svg"); // Next already prefixes SVGs with CDN
    if (props.src && process.env.NEXT_PUBLIC_TRAILWAYS_IMAGES_CDN && !isSvg) {
        return (
            <Image alt={props.alt} {...props} loader={cdnLoader} />
        )
    } else {
        return (
            <Image alt={props.alt} {...props} />
        )
    }
}

export default ResizedCdnImage